import styled from "styled-components";

/**
 * @prop {boolean} fullScreenRight
 */
export const PropertiesContainer = styled.div`
  position: relative;
  bottom: 1px;
  right: -1px;
  z-index: 9;
  display: flex;
  position: fixed;
  top: 170px;
  width: ${props => props.fullscreenRight ? '0px' : '300px'};
  height: auto;
  margin: -50px 0 0 0;

  .containerProperties {
    transition: width 200ms;
    flex-direction: column;
    align-items: flex-start;
    overflow-y: scroll;
    height: 106%;
    margin: -42px -30px 0px -5px;
    background-color: #efefef;
  }

  @media screen and (min-width: 600px) and (max-width: 1241px){
    * {
      transform: scale(0.8);
    }
  }

  @media (min-width: 1280px) and (max-width: 1359px) {
    right: -44px;

    .containerProperties {
      height: 140vh;
      margin: -210px -10px 0 0;
      transform: scale(0.65);
      width: 350px;
    }
  }

  @media (min-width: 1360px) and (max-width: 1439px) {
    right: -24px;

    .containerProperties {
      height: 118vh;
      margin: -147px -12px 0 0;
      transform: scale(0.77);
      width: 350px;
    }
  }

  @media (min-width: 1440px) and (max-width: 1599px) {
    right: -24px;

    .containerProperties {
      height: 119vh;
      margin: -160px -12px 0 0;
      transform: scale(0.77);
      width: 350px;
    }
  }

  @media (min-width: 1600px) and (max-width: 1799px) {
    right: 0px;

    .containerProperties {
      height: 101vh;
      margin: -92px -16px 0 0;
      transform: scale(0.9);
      width: 350px;
    }
  }

  @media (min-width: 1800px) and (max-width: 2559px) {
    right: 27px;

    .containerProperties {
      height: 93vh;
      margin: -51px -31px 0 0;
      transform: scale(0.98);
      width: 400px;
    }
  }

  @media (min-width: 2560px) and (max-width: 3839px) {
    right: 20px;
  
    .containerProperties {
      height: 83vh;
      margin: -5px -30px 0 0;
      transform: scale(1.1);
      width: 400px;
    }
  }

  @media (min-width: 3840px) {
    right: 20px;
    

    .containerProperties {
      height: 85vh;
      margin: 30px -30px 0 0;
      transform: scale(1.1);
      width: 400px;
    }
  }
`;
